<template>
  <div :style="{ height: this.getHeight(), position: position}"
       class="nav_main nav_main_cat">
    <ul :id="'bubbles-nav-0'" class="nav_list plr">
      <li :id="bubbleId(category)" v-for="category in categories" :key="category.id">
        <a :class="{act: active(category)}"
           @click="selectCategory(category)">{{category.name}}</a>
      </li>
    </ul>
  </div>
</template>

<script>

  import {SET_SELECTED_CATEGORY} from '@/store/mutations.type'
  import {mapGetters} from 'vuex'

  export default {
    name: 'BubblesNavbar',
    data() {
      return {
        product_bubble_prefix: 'product_bubble_prefix',
        position: 'sticky',
        level: 0,
        height: 36
      }
    },
    components: {},
    computed: {
      categories() {
        let categories = []
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].level === 0) {
            categories.push(this.$store.getters.categories[i])
          }
        }
        return categories
      },
      ...mapGetters(['modal'])
    },
    watch: {
      currentCategory(category) {
        this.scrollToBubble(category)
        this.getChildren(category)
      },
      modal: {
        deep: true,
        handler: function (modal) {
          // if (modal.search) {
          //   this.position = 'inherit'
          // } else {
          //   setTimeout(() => {
          //     this.position = 'sticky'
          //   }, 300)
          // }
        }
      }
    },
    mounted() {
      this.$store.subscribe(mutation => {
        if (mutation.type === SET_SELECTED_CATEGORY) {
          for (let i in this.categories) {
            if (mutation.payload && this.categories[i].id === mutation.payload.id) {
              this.scrollToBubble(this.categories[i])
            }
          }
        }
      })
    },
    methods: {
      active(category) {
        if (!this.$store.getters.selectedCategory) {
          return category.id === null && this.$route.name !== 'home'
        }
        return this.$store.getters.selectedCategory &&
          (
            this.$store.getters.selectedCategory.id === null && category.id === null ||
            this.$store.getters.selectedCategory.id === category.id ||
            this.isAncestor(category, this.$store.getters.selectedCategory)
          )
      },

      isAncestor(possibleAncestor, grandChild) {
        if (grandChild.parent_id === null) {
          return false
        }
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].id === grandChild.parent_id) {
            if (this.$store.getters.categories[i].id === possibleAncestor.id) {
              return true
            } else {
              return this.isAncestor(possibleAncestor, this.$store.getters.categories[i])
            }
          }
        }
        return false
      },

      getHeight() {
        return this.height + 'px'
      },

      bubbleId(category) {
        return this.product_bubble_prefix + category.id
      },

      selectCategory(category) {
        this.$store.commit(SET_SELECTED_CATEGORY, category)
        if (this.$route.name !== 'catalog') {
          this.$router.push({name: 'catalog', params: {token: this.$store.getters.token}})
        }
      },

      scrollToBubble(category) {
        if (!category || category.id == null) {
          return
        }

        let nav = document.getElementById('bubbles-nav-0')

        if (!nav) {
          return
        }

        let parent = nav.parentElement
        let bubble = document.getElementById(this.bubbleId(category))

        if (bubble) {
          parent.scrollLeft += bubble.getBoundingClientRect().x - parent.getBoundingClientRect().x
          if (Math.abs(Math.floor(parent.getBoundingClientRect().x - bubble.getBoundingClientRect().x)) < 10) {
            parent.scrollLeft += (-30)
          }
        }
      }
    }
  }
</script>
